import { Dropdown, DropdownItem } from '@frontend/components/common';

import useAccountMembership from './account-membership.controller';

interface Props {
    className?: string;
    buttonStyle?: string;
}
const AccountMembership = (props: Props) => {
    const viewProps = useAccountMembership();

    return viewProps.accounts.length > 1 ? (
        <Dropdown
            hideChevron
            buttonStyle={props.buttonStyle}
            className={props.className}
            label={viewProps.isSwitching ? 'Switching…' : (viewProps.selectedAccount?.name ?? 'Select account')}
            styles={{
                button: {
                    background: 'bg-brand-light'
                },
                nested: {
                    text: 'text-brand-light'
                },
                label: {
                    text: 'font-extrabold text-brand-muted'
                }
            }}>
            {viewProps.accounts.map((acc) => {
                return (
                    <DropdownItem
                        key={acc.id}
                        label={acc.name}
                        className='text-brand-muted'
                        onClick={() => {
                            if (!viewProps.isSwitching) {
                                viewProps.onChangeMembership(acc.id);
                            }
                        }}
                    />
                );
            })}
        </Dropdown>
    ) : (
        <div
            id={`${viewProps.selectedAccount?.name.toString().toLocaleLowerCase().replace(' ', '-')}-button`}
            className='text-brand-muted border-border-default flex h-full items-center border-l px-5 font-extrabold uppercase'>
            {viewProps.selectedAccount?.name}
        </div>
    );
};

export default AccountMembership;
